import React from "react";

export default function TemoignageCard({ temoignage }) {
  return (
    <>
      <div className="d-flex align-items-center w-100">
        <video
          src={temoignage.video}
          className="card-img-top h-100 w-100"
          style={{
            width: "100%",
            height: "auto",
            objectFit: "cover",
            maxHeight: "200px",
          }}
          controls
        />
      </div>
      {/* Central Section for Title and Location */}
      <div
        className="flex-grow-1 text-center"
        style={{
          padding: "0 15px",
          borderLeft: "1px solid #ccc",
          borderRight: "0px solid #ccc",
        }}
      >
        <p
          className=" text-dark text-center fw-bold  py-2 custom-titre-h1 text-dark"
          style={{ margin: 0, fontSize: "10px" }}
        >
          {temoignage.title}
        </p>
        <p className="text-muted text-left custom-p">{temoignage.description}</p>
      </div>
    </>
  );
}
